import { MenuItem } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import { makeStyles } from 'tss-react/mui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateSelectedUserType } from '../../store/actions/userProfileActions';
import { getSelectedUserType, getUserProfile } from '../../store/selectors/selectors';
import { COLORS, LABEL, RoleCodes } from '../../theme/constants';
import { loadSelectedContainersSucceeded } from '../../store/actions/selectedContainerActions';
import { getValidRoles } from '../../auth/helper';

const styles = () => ({
  formControl: {
    minWidth: 120,
    verticalAlign: 'middle',
  },
  changeUser: {
    color: 'white',
  },
  select: {
    color: 'white !important',
  },
  icon: {
    color: 'white',
  },
});

const useOutlinedInputStyles = makeStyles()(() => ({
  root: {
    color: 'white',
    '& .MuiOutlinedInput-input': {
      color: 'white',
    },
    '& .MuiSelect-select': {
      color: 'white',
    },
    '& .MuiSelect-icon': {
      color: 'white',
    },
    '& $notchedOutline': {
      borderColor: COLORS.BLACK,
      borderWidth: '1px',
    },
    '&:hover $notchedOutline': {
      borderColor: COLORS.BLACK,
      borderWidth: '1px',
    },
    '&$focused $notchedOutline': {
      borderColor: COLORS.BLACK,
      borderWidth: '1px',
    },
  },
  focused: {},
  notchedOutline: {},
}));

const UserProfileSelect = (props) => {
  const {
    classes,
    userProfile,
    selectedUserType,
    updateSelectedUserType,
    loadSelectedContainersSucceeded,
  } = props;

  const handleChange = (event) => {
    localStorage.setItem('selectedUserType', event.target.value);
    updateSelectedUserType(event.target.value);
    loadSelectedContainersSucceeded([]);
  };

  const outlinedInputClasses = useOutlinedInputStyles();

  return (
    <>
      <FormControl className={classes.formControl}>
        <Select
          classes={{ select: classes.select, icon: classes.icon }}
          value={selectedUserType}
          displayEmpty
          onChange={handleChange}
          input={<OutlinedInput classes={outlinedInputClasses} />}
        >
          <MenuItem value={''} disabled>
            {LABEL.CHANGE_USER}
          </MenuItem>
          {getValidRoles(userProfile.roles).map((role) => {
            switch (role) {
              case RoleCodes.RELEASE_PARTY_EDITOR_CODE:
              case RoleCodes.RELEASE_PARTY_VIEWER_CODE:
                return (
                  <MenuItem key={LABEL.FORWARDER} value={role}>
                    {LABEL.FORWARDER}
                  </MenuItem>
                );
              case RoleCodes.TERMINAL_EDITOR_CODE:
              case RoleCodes.TERMINAL_VIEWER_CODE:
                return (
                  <MenuItem key={LABEL.TERMINAL} value={role}>
                    {LABEL.TERMINAL}
                  </MenuItem>
                );
              case RoleCodes.SHIP_AGENT_EDITOR_CODE:
              case RoleCodes.SHIP_AGENT_VIEWER_CODE:
                return (
                  <MenuItem key={LABEL.SHIPPING} value={role}>
                    {LABEL.SHIPPING_AGENT}
                  </MenuItem>
                );
              case RoleCodes.TRANSPORT_OPERATOR_EDITOR_CODE:
              case RoleCodes.TRANSPORT_OPERATOR_VIEWER_CODE:
                return (
                  <MenuItem key={LABEL.TRANSPORTOPERATOR_LABEL} value={role}>
                    {LABEL.TRANSPORTOPERATOR_LABEL}
                  </MenuItem>
                );
              default:
                return <div />;
            }
          })}
        </Select>
      </FormControl>
    </>
  );
};

UserProfileSelect.propTypes = {
  userProfile: PropTypes.object.isRequired,
  selectedUserType: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    userProfile: getUserProfile(state),
    selectedUserType: getSelectedUserType(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateSelectedUserType,
      loadSelectedContainersSucceeded,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(UserProfileSelect, styles));
